export default __webpack_public_path__ + "images/SpeakersPhotos/JustoHidalgo.headshot.HD.jpg?e8fcbb39";